<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<div *ngIf="isLoaded && realizations">

    <!--<h4 *ngIf="!course" class="hide-on-small-only">404</h4>-->
    <h1 *ngIf="!course" class="hide-on-med-and-up">404</h1>
    <div *ngIf="course">
    <!--<h4 class="hide-on-small-only">
        <span *ngIf="creditPoints && course?.maxCredits>course?.minCredits">{{course?.code}} {{globals.getLocalizedValueIfAny(course?.name)}}, {{course?.minCredits}}-{{course?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
        <span *ngIf="creditPoints && course?.maxCredits==course?.minCredits">{{course?.code}} {{globals.getLocalizedValueIfAny(course?.name)}}, {{course?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
    </h4>-->
        <h1 class="hide-on-med-and-up">
            <span *ngIf="creditPoints && course?.maxCredits>course?.minCredits">{{course?.code}} {{globals.getLocalizedValueIfAny(course?.name)}}, {{course?.minCredits}}-{{course?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
            <span *ngIf="creditPoints && course?.maxCredits==course?.minCredits">{{course?.code}} {{globals.getLocalizedValueIfAny(course?.name)}}, {{course?.maxCredits}} {{globals.getLocalizedValueIfAny(creditPoints)}}</span>
            <span *ngIf="showTags" class="tooltip-container"><!--class="tooltip" -->
                <span *ngFor="let tag of course?.tags"
                    matTooltip={{globals.getLocalizedValueIfAny(tag?.title)}}
                    [matTooltipPosition]="'right'"
                    matTooltipShowDelay="500">
                    <i *ngIf="tag.code === 'KEKE'"class="small material-symbols-outlined">potted_plant</i>
                    <i *ngIf="tag.code === 'OT'"class="small material-icons">work</i>
                    <i *ngIf="tag.code === 'KV'"class="small material-icons">public_</i>
                    <!--<span class="tooltiptext">{{globals.getLocalizedValueIfAny(tag?.title)}}</span>-->
                </span>     
            </span>
        </h1>

        <div >
            <!--Toteutukset-->
            <div class="realizations">
                <h2 *ngIf="realizationsHeader && realizations?.length>0">{{globals.getLocalizedValue(realizationsHeader)}}</h2>
                <app-realizations *ngIf="realizations?.length>0" [id]="id" [realizations]="realizations" [past] = false></app-realizations>
            </div>
            <!--Menneet Toteutukset-->
            <a *ngIf="showPastRealizationsLink &&  !showPastRealizations" (keydown)="showRealizations($event)" (click)="getPastRealizations()" class="link" tabindex="0">{{globals.getLocalizedValue(showPastRealizationsLink)}}</a>
            <div *ngIf="showPastRealizations" class="realizations">
                <h2 *ngIf="pastRealizationsHeader">{{globals.getLocalizedValue(pastRealizationsHeader)}}</h2>
                <app-realizations *ngIf="pastRealizations?.length>0" [id]="id" [realizations]="pastRealizations" [past] = true></app-realizations>
            </div>

            <!--Jakson tiedot-->
            <div class="flex-content">

                <div *ngFor="let item of course?.contentList" >
                    <div *ngIf="globals.getLocalizedValueIfAny(item?.content)"  class="flex-content-item"> <!--class="col s12 m6"-->
                        <h2>{{globals.getLocalizedValueIfAny(item?.title)}}</h2>
                        <!-- {{globals.getLocalizedValue(item?.content)}}-->
                        <app-markdown [body]="globals.getLocalizedValueIfAny(item?.content)"></app-markdown>
                    </div>
                </div>

                <!--Jakso sisältyy OPSeihin:-->
                <div>
                    <app-programmes [id]="id"></app-programmes>
                </div>

            </div>

        </div>

    </div>

</div>

<!-- TOIMIVA KOKEILU
<cdk-accordion class="example-accordion">
    <cdk-accordion-item
      *ngFor="let item of items; let index = index;"
      #accordionItem="cdkAccordionItem"
      class="example-accordion-item"
      role="button"
      tabindex="0"
      [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded"
      [attr.aria-controls]="'accordion-body-' + index">
      <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
        {{ item }}
        <span class="example-accordion-item-description">
          Click to {{ accordionItem.expanded ? 'close' : 'open' }}
        </span>
      </div>
      <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItem.expanded ? '' : 'none'"
        [attr.id]="'accordion-body-' + index"
        [attr.aria-labelledby]="'accordion-header-' + index">
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perferendis
        excepturi incidunt ipsum deleniti labore, tempore non nam doloribus blanditiis
        veritatis illo autem iure aliquid ullam rem tenetur deserunt velit culpa?
      </div>
    </cdk-accordion-item>
  </cdk-accordion>-->